import type { DashboardSettlementViewModel } from '@/lib/venue/dashboardViewModel'

/** 정산 요약 — 대시보드 EP 의 `settlement`(#591 §4-2, 실데이터). */
export function DashboardSettlementSummary({ settlement }: { settlement: DashboardSettlementViewModel }) {
  return (
    <dl className="grid grid-cols-1 gap-3 sm:grid-cols-2">
      <div>
        <dt className="text-xs text-slateish-600">이번 달 확정 금액{settlement.estimated ? ' (예정)' : ''}</dt>
        <dd className="mt-1 text-lg font-semibold text-ink-700">{settlement.confirmedAmountText}</dd>
      </div>
      <div>
        <dt className="text-xs text-slateish-600">다음 정산</dt>
        <dd className="mt-1 text-lg font-semibold text-ink-700">{settlement.nextPayoutText}</dd>
      </div>
      <div className="sm:col-span-2">
        <dt className="text-xs text-slateish-600">처리 중 환불</dt>
        <dd className="mt-1 text-sm text-slateish-700">{settlement.inProgressRefundText}</dd>
      </div>
    </dl>
  )
}
